module.exports = __webpack_public_path__ + "static/img/iphone_room_title1.7b5e48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_title1.png
// module id = INGr
// module chunks = 0